import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
/**
 * HOC to set height and width of SVG icon to auto when unset
 * @param WrappedComponent The component to use auto height & width
 */ export var withAutoDimension = function(WrappedComponent) {
    var Component = function(props) {
        var _props_height;
        var height = (_props_height = props.height) !== null && _props_height !== void 0 ? _props_height : "auto";
        var _props_width;
        var width = (_props_width = props.width) !== null && _props_width !== void 0 ? _props_width : "auto";
        return /*#__PURE__*/ _jsx(WrappedComponent, _object_spread_props(_object_spread({}, props), {
            height: height,
            width: width
        }));
    };
    return Component;
};
